import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["id", "spa", "env", "api", "reportApiSpeed", "reportAssetSpeed", "expectedApiRespCode", "ignoreDataUrls"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import Aegis from '@tencent/aegis-web-sdk';
import { reportErrorLogImpl } from './util';
export var COMMON_EXPECTED_API_RESP_CODE = [200, 0, 'Success'];
var aegisIns = null;
export var initAegis = function initAegis(config) {
  if (aegisIns) {
    return aegisIns;
  }
  var id = config.id,
    spa = config.spa,
    env = config.env,
    api = config.api,
    reportApiSpeed = config.reportApiSpeed,
    reportAssetSpeed = config.reportAssetSpeed,
    expectedApiRespCode = config.expectedApiRespCode,
    _config$ignoreDataUrl = config.ignoreDataUrls,
    ignoreDataUrls = _config$ignoreDataUrl === void 0 ? [] : _config$ignoreDataUrl,
    extra = _objectWithoutProperties(config, _excluded);
  var apiRespCode = [].concat(COMMON_EXPECTED_API_RESP_CODE, _toConsumableArray(expectedApiRespCode || []));
  aegisIns = new Aegis(_objectSpread({
    id: id,
    reportApiSpeed: reportApiSpeed,
    reportAssetSpeed: reportAssetSpeed,
    spa: spa,
    env: env,
    hostUrl: 'https://aegis.qq.com',
    api: _objectSpread({
      apiDetail: false,
      retCodeHandler: function retCodeHandler(_data, url, xhr) {
        var success = xhr.status === 200 || xhr.status === 304;
        try {
          var ignore = ignoreDataUrls.some(function (re) {
            return re.test(url);
          });
          if (ignore) {
            return {
              isErr: !success,
              code: xhr.status
            };
          }
        } catch (err) {
          console.error('check ignore error: ', url, xhr.status);
        }
        try {
          var respData = JSON.parse(xhr.response) || {};
          if (!apiRespCode.includes(respData.code)) {
            success = false;
          }
        } catch (_a) {
          success = false;
        }
        if (!success) {
          console.error('retCodeHandler', url, xhr.status);
        }
        return {
          isErr: !success,
          code: xhr.status
        };
      },
      reportRequest: true
    }, api)
  }, extra));
  return aegisIns;
};
export var reportAegisCustomEvent = function reportAegisCustomEvent(option) {
  if (!aegisIns) {
    console.error('请先初始化aegis实例');
    return;
  }
  var name = option.name,
    data = option.data;
  aegisIns.reportEvent({
    name: name,
    ext3: JSON.stringify(data || {})
  });
};
export var reportAegisErrorLog = function reportAegisErrorLog(log) {
  if (!aegisIns) {
    console.error('请先初始化aegis实例');
    return;
  }
  reportErrorLogImpl(aegisIns, log);
};